// Turkic Silk Road mobil uygulama mağaza bağlantıları
export const APP_LINKS = {
  appStore: 'https://apps.apple.com/tr/app/turkic-silk-road/id6781444501',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.turkicsilkroad.app',
};
